export const AUTOMAP_WHATSAPP_INTAKE_SOURCE = "automapa_whatsapp_widget";

export const AUTOMAP_WHATSAPP_INTAKE_STEPS = [
  "greeting",
  "name",
  "whatsapp",
  "email",
  "financing",
  "financingDetails",
  "notes",
  "review",
  "submitting",
  "success",
  "error",
];

export const AUTOMAP_WHATSAPP_SUBMIT_COPY = {
  loading: "Enviando tu consulta…",
  success: "Recibimos tu consulta. AutoMapa continuará por WhatsApp.",
  error: "No pudimos enviar la consulta. Intenta de nuevo o continúa en WhatsApp.",
  consentRequired: "Necesitamos tu autorización para enviar la consulta.",
  featureDisabled:
    "Esta función no está disponible en este momento. Puedes continuar en WhatsApp.",
};

export const AUTOMAP_WHATSAPP_LOAN_TERM_OPTIONS = [12, 24, 36, 48, 60, 72];

export const AUTOMAP_WHATSAPP_FINANCING_OPTIONS = [
  { value: "yes", label: "Sí" },
  { value: "no", label: "No" },
  { value: "unsure", label: "No estoy seguro" },
];

export const AUTOMAP_WHATSAPP_ENTRY_POINTS = {
  FLOATING_FAB: "floating_fab",
  VEHICLE_CARD: "vehicle_card",
  VEHICLE_DETAIL: "vehicle_detail",
  OTHER: "other",
};

export function resolveAutomapWhatsappEntryPoint(context = null) {
  const source = String(context?.source || context?.sourceAction || "").toLowerCase();
  if (!source || source === "floating_fab" || source === "fab") {
    return AUTOMAP_WHATSAPP_ENTRY_POINTS.FLOATING_FAB;
  }
  if (
    source.includes("search") ||
    source.includes("homepage") ||
    source.includes("card") ||
    source.includes("saved")
  ) {
    return AUTOMAP_WHATSAPP_ENTRY_POINTS.VEHICLE_CARD;
  }
  if (source.includes("detail") || source.includes("vehicle_detail")) {
    return AUTOMAP_WHATSAPP_ENTRY_POINTS.VEHICLE_DETAIL;
  }
  return AUTOMAP_WHATSAPP_ENTRY_POINTS.OTHER;
}
